import React, { createContext, useState } from "react";
import PropTypes from "prop-types";

export const DistrictContext = createContext();

export const DistrictContextProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [formIsEdit, setFormIsEdit] = useState(false);
  const [editData, setEditData] = useState({});

  const handleOpenModal = () => {
    setOpen(true);
    setFormIsEdit(false);
  };

  return (
    <DistrictContext.Provider
      value={{
        open,
        setOpen,
        formIsEdit,
        setFormIsEdit,
        handleOpenModal,
        editData,
        setEditData,
      }}
    >
      {children}
    </DistrictContext.Provider>
  );
};

export default DistrictContextProvider;
DistrictContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
